import { Button } from "@/shared/ui/button";
import { Label } from "@/shared/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Camera, Upload, X, Image } from "lucide-react";

interface MediaTabProps {
  facilityImage: string | null;
  onUploadClick: () => void;
  onRemoveImage: () => void;
}

export function MediaTab({ facilityImage, onUploadClick, onRemoveImage }: MediaTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Camera className="h-4 w-4" />
          Property Media
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Facility Image</Label>
            <div className="border-2 border-dashed border-border rounded-lg p-6 text-center">
              {facilityImage ? (
                <div className="space-y-4">
                  <img
                    src={facilityImage}
                    alt="Facility preview"
                    className="mx-auto max-h-48 rounded-lg object-cover"
                  />
                  <div className="flex gap-2 justify-center">
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      onClick={onUploadClick}
                    >
                      <Upload className="h-4 w-4 mr-2" />
                      Change Image
                    </Button>
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      onClick={onRemoveImage}
                    >
                      <X className="h-4 w-4 mr-2" />
                      Remove
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="space-y-4">
                  <Image className="h-12 w-12 text-muted-foreground mx-auto" />
                  <div>
                    <Button
                      type="button"
                      variant="outline"
                      onClick={onUploadClick}
                    >
                      <Upload className="h-4 w-4 mr-2" />
                      Upload Facility Image
                    </Button>
                    <p className="text-sm text-muted-foreground mt-2">
                      Optional: Add a photo of the property exterior or main view
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
